import { WithChildrenCommonProps } from '@shipengine/giger';
import { getBoxStyles } from './BoxStyles';

export function Box(props: WithChildrenCommonProps<unknown>): JSX.Element {
    return <section css={getBoxStyles} {...props} />;
}
